module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon3.9d660c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon3.png
// module id = USWr
// module chunks = 0